<div class="modal-header border-2 h5 modal-header pb-2 pt-2 text-bg-warning">
  Currently Active Sessions
  <div
    class="h6"
    triggers="hover"
    ngbTooltip="Currently you have more sessions of the editor opened than you are licensed for.">
    What is this?
    <i class="bi-question-circle-fill text-ellipsis h6"></i>
  </div>
  <button *ngIf="closeEnabled" type="button" class="btn btn-titlebar" (click)="activeModal.dismiss()" title="Close">
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body ps-4 pt-0">
  <div *ngIf="loading" class="text-center h-100 d-flex">
    <div class="loader-container d-flex flex-column h-100 w-100 justify-content-center loader-container">
      <!-- <div class="background"></div> -->
      <div class="loader-container translucent-div">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden"></span>
        </div>
        <div>Loading Document Sessions...</div>
      </div>
    </div>
  </div>
  <!-- Original Header -->
  <header class="grid gap-1 position-sticky top-0 px-4">
    <div class="g-col-6">Document name</div>
    <div class="g-col-3">Last Active Time</div>
    <div class="g-col-3">Actions</div>
  </header>
  <div class="tx-table h-100 d-block">
    <div *ngIf="sessions.length === 0 && !loading" class="text-center p-3">
      <p>No documents found.</p>
    </div>
    <div *ngIf="sessions.length != 0 && !loading" class="d-block h-100">
    <!-- Grouped Sessions -->
    <div *ngFor="let userAgentGroup of sessions">
      <!-- UserAgent Group Header -->
      <div class="group-header-user-agent px-4 position-sticky">
        <strong>Browser:</strong>
        {{ getUserAgentName(userAgentGroup.userAgent) }}
      </div>
      <div *ngFor="let initialsGroup of userAgentGroup.sessionsByInitials">
        <!-- Initials Group Header -->
        <div class="group-header-initials px-4 position-sticky">
          <strong>Staff initials:</strong>
          {{ initialsGroup.initials }}
        </div>
        <div *ngFor="let s of initialsGroup.sessions" class="grid tx-table-row gap-1 px-4">
          <div class="g-col-6 ps-1 d-flex align-items-center gap-3">
            <i [class]="'bi bi-' + getIconExtension(s.activeDcmPath)"></i>
            <div class="text-truncate mr-1" triggers="hover" [ngbPopover]="getDocumentNameTooltip(s)" container="body">
              <div class="text-truncate"><span *ngIf="isDirty(s)">* </span>{{ getDocumentName(s) }}</div>
              <div class="text-truncate" *ngIf="s.contactLastName && s.casDescription">
                <span><strong>Contact:</strong> {{ s.contactFirstName + ' ' + s.contactLastName }}   </span>
                <span><strong>Case:</strong> {{ s.casDescription }}</span>
              </div>
            </div>
          </div>
          <div class="g-col-3">
            {{
              s.dateAutosaved != null
                ? (s.dateAutosaved | date : 'MM/dd/yyyy h:mm a')
                : (s.dateCreated | date : 'MM/dd/yyyy h:mm a')
            }}
          </div>
          <div class="g-col-3">
            <div class="d-flex align-items-center gap-2 h-100">
              <button
              type="button"
              class="btn btn-outline-primary btn-sm sbtn py-3"
              triggers="click"
              placement="left"
              *ngIf="s.txTextControlSessionId"
              (shown)="getSessionThumbnail(s)"
              (hidden)="clearSessionThumbnail()"
              [ngbPopover]="popImagePreviewContent"
              container="body">
              <i class="bi bi-binoculars-fill"></i>
            </button>
              <button
                type="button"
                class="btn btn-outline-primary btn-sm sbtn"
                (click)="onTakeoverClicked(s, initialsGroup, userAgentGroup)"
                triggers="hover"
                  [openDelay]="300"
                  ngbPopover="Opens the document in the current state in this browser and closes it in the other broswer."
                  container="body">
                Take over
              </button>
              <button
                *ngIf="showSaveButton(s)"
                type="button"
                class="btn btn-outline-danger btn-sm sbtn"
                (click)="onSaveClicked(s, initialsGroup, userAgentGroup)"
                triggers="hover"
                [openDelay]="300"
                ngbPopover="Saves changes and closes the document."
                container="body">
                Save & Close
              </button>
              <button
                type="button"
                class="btn btn-outline-danger btn-sm sbtn"
                (click)="onCloseClicked(s, initialsGroup, userAgentGroup)"
                triggers="hover"
                [openDelay]="300"
                ngbPopover="Discards changes and closes the document."
                container="body">
                Discard & Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <form
        ngNoForm
        [action]="submitUrl"
        method="post"
        enctype="application/x-www-form-urlencoded"
        target="_blank"
        #openInNewTabForm>
        <input type="hidden" id="filename" name="filename" />
        <input type="hidden" [id]="sessionId" [name]="sessionId" />
        <input type="hidden" id="activeSessionId" name="activeSessionId" />
        <input type="hidden" id="activeSessionAnswerPoolId" name="activeSessionAnswerPoolId" />
      </form>
    </div>
    </div>
  </div>
</div>

<ng-template #popImagePreviewContent>
  <div *ngIf="loadingPreview" class="text-center d-flex" style="height: 40%">
    <div class="loader-container d-flex flex-column h-100 w-100 justify-content-center loader-container">
      <!-- <div class="background"></div> -->
      <div class="loader-container translucent-div">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden"></span>
        </div>
        <div>Loading preview...</div>
      </div>
    </div>
  </div>
  <div *ngIf="!loadingPreview && previewImage" class="text-center d-flex" style="width: 400px">
    <img [src]="previewImage" width="400px" />
  </div>
</ng-template>
